export default {
  financingList: {
    url: '/financingList',
    method: 'post',
  },
  financingUndoList: {
    url: '/financingUndoList',
    method: 'post',
  },
  financingUndoDetail: {
    url: '/financingUndoDetail',
    method: 'post',
  },
  financingSave: {
    url: '/financingSave',
    method: 'post',
  },
  checkBank: {
    url: '/check/cor/sign',
    method: 'post'
  },
  financingDetail: {
    url: '/financingDetail',
    method: 'post',
  },
  sendCheckCode: {
    url: '/api/sendCheckCode',
    method: 'post',
  },
  financingFileUpload: {
    url: '/financingFileUpload',
    method: 'post'
  },
  financingFileDelete: {
    url: '/financingFileDelete',
    method: 'post'
  },
  financingFileDownload: {
    url: '/financingFileDownload',
    method: 'post',
    responseType: 'blob'
  },
  bankList: {
    url: '/bankList',
    method: 'post',
  },
  getDict: {
    url: '/getDict',
    method: 'post',
  },
  supplierInfoSelect: {
    url: '/supplierInfoSelect',
    method: 'post',
  },
  financingExport: {
    url: '/financingExport',
    method: 'post',
    responseType: 'blob'
  },
  checkSupplierRegisterStatus: {
    url: '/checkSupplierRegisterStatus',
    method: 'post',
  },
  scfInvoiceList: {
    url: '/scfInvoice/list',
    method: 'post',
  }
};
